import { useState, useEffect } from 'react';

const WMO_CODES = {
  0: { label: 'Clear', mood: 'clear' },
  1: { label: 'Mainly Clear', mood: 'clear' },
  2: { label: 'Partly Cloudy', mood: 'cloud' },
  3: { label: 'Overcast', mood: 'cloud' },
  45: { label: 'Foggy', mood: 'rain' },
  48: { label: 'Icy Fog', mood: 'rain' },
  51: { label: 'Light Drizzle', mood: 'rain' },
  53: { label: 'Drizzle', mood: 'rain' },
  55: { label: 'Heavy Drizzle', mood: 'rain' },
  61: { label: 'Light Rain', mood: 'rain' },
  63: { label: 'Rain', mood: 'rain' },
  65: { label: 'Heavy Rain', mood: 'rain' },
  71: { label: 'Light Snow', mood: 'rain' },
  73: { label: 'Snow', mood: 'rain' },
  75: { label: 'Heavy Snow', mood: 'rain' },
  80: { label: 'Showers', mood: 'rain' },
  95: { label: 'Thunderstorm', mood: 'rain' },
};

export function useWeather() {
  const [weather, setWeather] = useState(null);

  useEffect(() => {
    // Boston coords
    fetch('https://api.open-meteo.com/v1/forecast?latitude=42.3601&longitude=-71.0589&current=temperature_2m,weathercode&temperature_unit=fahrenheit&timezone=America%2FNew_York')
      .then(r => r.json())
      .then(d => {
        const code = d.current.weathercode;
        const temp = Math.round(d.current.temperature_2m);
        const info = WMO_CODES[code] || { label: 'Unknown', mood: 'clear' };
        setWeather({ temp, label: info.label, mood: info.mood, code });
      })
      .catch(() => setWeather({ temp: null, label: 'Boston', mood: 'clear' }));
  }, []);

  return weather;
}

export function getMoodClass(weather, hour) {
  if (!weather) return '';
  if (hour >= 20 || hour < 6) return 'mood-night';
  if (weather.mood === 'rain') return 'mood-rain';
  if (hour >= 17 && hour < 20) return 'mood-dusk';
  return '';
}

export function getGreeting(hour, dayOfWeek) {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const day = days[dayOfWeek];
  if (hour >= 5 && hour < 12) return { greeting: 'Good morning', note: `It's ${day} in Boston — Mekhal is likely deep in work.` };
  if (hour >= 12 && hour < 17) return { greeting: 'Good afternoon', note: `It's ${day} in Boston — available for conversations.` };
  if (hour >= 17 && hour < 20) return { greeting: 'Good evening', note: `It's ${day} evening — Mekhal is building after hours.` };
  return { greeting: 'Hey, night owl', note: `It's late in Boston — leave a message.` };
}
